import { Component, Input, OnInit, inject } from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {ConfigurationHelper} from '../../generic/helper/configuration.helper';
import {BlogService} from '../../service/blog.service';
import {Blog} from '../blog/blog';

@Component({
	templateUrl: './productdetail.grower.blog.component.html',
	selector: 'product-grower-blog',
	styleUrls: ['./productdetail.grower.blog.component.scss'],
	standalone: true,
	imports: [RouterLink],
})
export class ProductdetailGrowerBlogComponent implements OnInit {
	private readonly blogService = inject(BlogService);
	private readonly router = inject(Router);

	@Input() grower: string;
	blogItem: Blog | null;
	productOverviewUrl: string;

	ngOnInit(): void {
		if (!this.isEmptyString(this.grower)) {
			this.blogService
				.getBlogForGrower(this.grower)
				.then(result => (this.blogItem = result))
				.catch(() => {
					this.blogItem = null;
				});
		}
	}

	getCmsUrl(relativeUrl: string): string {
		return ConfigurationHelper.getWebsiteUrl(relativeUrl);
	}

	isEmptyString(stringToCheck: string): boolean {
		return stringToCheck.length === 0 || !stringToCheck.trim();
	}

	isValidBlog() {
		return this.blogItem?.blogId;
	}

	isNovifloraBlog() {
		return this.blogItem?.blogUrl;
	}

	hasGrowerName() {
		return this.blogItem?.growerName;
	}

	public getShowAllProductsUrl() {
		this.productOverviewUrl = `/products?grower=${this.grower}`;
		return this.router.navigateByUrl(this.productOverviewUrl);
	}
}
